export default __webpack_public_path__ + "static/media/7 - Teeth Intro.3560916c.mp3";